module.exports = __webpack_public_path__ + "static/media/detail-hero.9fb55fef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/give/detail-hero.jpg
// module id = 2013
// module chunks = 0